
import { defineComponent, PropType } from 'vue'
import { MetricType, StatType } from '~/types/metric'
import { Metric, MetricNamespaceTrend } from '~/types/types'
import { dateRangeOptions } from '~/utils/date'
import { formatIntl } from '~/utils/string'

export default defineComponent({
  name: 'TrendTitle',
  props: {
    dateRange: {
      type: String,
      default: '7d'
    },
    namespacesTrend: {
      type: Object as PropType<MetricNamespaceTrend>,
      required: true
    },
    metricMeta: {
      type: Object as PropType<{
        shortcode?: Metric['shortcode']
        name?: Metric['name']
        description?: Metric['description']
        supportsAggregateThreshold?: Metric['supportsAggregateThreshold']
      }>,
      required: true
    }
  },
  data() {
    return {
      STAT_TYPE: StatType,
      AGGREGATE_METRIC_KEY: MetricType.aggregate,
      METRICS_DOC:
        'https://docs.deepsource.com/docs/repository-view-metrics#metric-aggregate-calculation',
      dateRangeOptions
    }
  },
  computed: {
    isAggregate(): boolean {
      return this.namespacesTrend.key === this.AGGREGATE_METRIC_KEY
    },
    analyzerInformation() {
      return {
        shortcode: this.namespacesTrend.analyzerShortcode,
        name: this.namespacesTrend.key,
        analyzerLogo: this.namespacesTrend.analyzerLogo
      }
    }
  },
  created() {
    if (process.client) {
      const { provider, owner, repo } = this.$route.params

      const cachedDateRange = this.$localStore.get(
        `${provider}-${owner}-${repo}`,
        'metrics-last-duration-filter'
      )

      if (cachedDateRange) {
        this.$emit('update-filter', cachedDateRange)
      }
    }
  },
  methods: {
    formatIntl,
    updateDateRange(dateRangeFromEmit: string): void {
      this.$emit('update-filter', dateRangeFromEmit)
    }
  }
})
